// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-button[data-v-65d0d30c] {\n  margin-right: 0.26667rem;\n  vertical-align: top;\n  display: inline-block;\n}\n.page-button[data-v-65d0d30c]:last-child {\n  margin-right: 0;\n}\n[data-v-65d0d30c] .el-button {\n  padding: 0.16rem 0.26667rem;\n  font-size: 0.32rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
